import React, { createContext, useContext, useMemo, useState } from 'react';
import type { Language } from '../types/i18n';
type LanguageContextValue = {
  language: Language;
  setLanguage: (language: Language) => void;
};
const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('nl');
  const value = useMemo(() => ({
    language,
    setLanguage
  }), [language]);
  return <LanguageContext.Provider value={value} data-id="element-91" data-mp="z4v61mimbfuq">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}